var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyselfOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39999 7.8H15.6M8.39999 11.8H12M19.2 10.2V5.4C19.2 4.07452 18.1255 3 16.8 3H7.19999C5.8745 3 4.79999 4.07452 4.79999 5.4V18.6C4.79999 19.9255 5.8745 21 7.19999 21H8.69999M17.9895 13.4895C18.1279 13.3462 18.2934 13.232 18.4764 13.1534C18.6594 13.0747 18.8562 13.0334 19.0554 13.0316C19.2546 13.0299 19.4521 13.0679 19.6364 13.1433C19.8208 13.2187 19.9882 13.3301 20.1291 13.4709C20.2699 13.6118 20.3813 13.7792 20.4567 13.9636C20.5321 14.1479 20.5701 14.3454 20.5684 14.5446C20.5666 14.7438 20.5253 14.9406 20.4466 15.1236C20.368 15.3066 20.2538 15.4721 20.1105 15.6105L13.671 22.05H11.55V19.929L17.9895 13.4895Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyselfOutline);
export default __webpack_public_path__ + "static/media/MyselfOutline.e3dfd7fe9914e6b0f30d4ea4d83734da.svg";
export { ForwardRef as ReactComponent };